import * as React from 'react';

import { useSelector } from 'react-redux';
import { LastChanceDiscountContent } from '../../../../components/LastChanceDiscount';
import { TopPromosContent } from '../../../../components/TopPromos';
import { selectPromoCompilationLabel, selectPromoCompilationTitle } from '../../../../selectors/promoComparison';
import { TPromoCompilationType } from '../../../../types/promoSelection';

export interface IPromoCompilationIllustrationProps {
  type: TPromoCompilationType;
}

export const PromoCompilationContentContainer: React.FC<IPromoCompilationIllustrationProps> = ({ type }) => {
  const title = useSelector(selectPromoCompilationTitle(type));
  const label = useSelector(selectPromoCompilationLabel(type));

  switch (type) {
    case 'topPromos':
      return <TopPromosContent title={title} label={label} />;
    case 'lastChanceDiscount':
      return <LastChanceDiscountContent title={title} label={label} />;
  }
};
